$(document).ready(function(e) {
	/* Выпадающие меню */
	$('.m_ctrl').on('click', function() {
		$('.hmm_wr').slideToggle(300);
	});

	/*Слайдер*/
	$('.slider:not(.false)').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		dots: true,
		appendArrows: '.slider_nav',
		appendDots: '.slider_nav',
		rows: 0,
		responsive: [
			{
				breakpoint: 1341,
				settings: {
					arrows: false
				}
			}
		]
	});

	/*Карусель*/
	$('.carousel').slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		rows: 0,
		responsive: [
			{
				breakpoint: 1061,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.carousel1').slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: true,
		rows: 0,
		responsive: [
			{
				breakpoint: 1061,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 801,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 731,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 481,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});

	$('.carousel2').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: true,
		rows: 0,
		responsive: [
			{
				breakpoint: 951,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 551,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	/*fancybox*/
	$("[data-fancybox]").fancybox({
		buttons : [
			'close'
		]
	});

	/*Форма*/
	$('input, select').styler({
		selectPlaceholder: '',
		selectVisibleOptions: 5
	});
	$('.switch input').styler('destroy');
	$('.switch1 input').styler('destroy');

	/*Вкладки*/
	$('.tabs_wr').tabs();
	$('.tabs_wr1').tabs();
	$('.tabs_wr2').tabs();

	$('.modal .close').click(function () {
		$('.modal').animate({left: '100%'}, 400);
	});

	$('[data-send]').on('click', function () {
		let modal = $(this).parents('.modal');
		let error = false;
		modal.find('.required').each(function () {
			if ($(this).val().length < 2) {
				$(this).css('border-color', 'rgba(220, 0, 0, 0.72)');
				error = true;
				return false;
			}
		});

		if (!error) {
			$.post(modal.find('form').attr('action'), modal.find('form').serialize(), function (json) {
				toastr[json.status](json.text);
				$('.modal').animate({left:'100%'},400);
			}, 'json');
		}
	})

	$('.h_menu > li').hover(function () {
		$(this).find('.hm_ddown').show();
	}, function () {
		$(this).find('.hm_ddown').hide();
	});

	$('[data-fancybox-img]').fancybox({

	});

	$(document).mouseup(function (e){ // событие клика по веб-документу
		var div = $(".modal__item"); // тут указываем ID элемента
		if (!div.is(e.target) // если клик был не по нашему блоку
			&& div.has(e.target).length === 0) { // и не по его дочерним элементам
			div.parent().animate({left: '+=100%'}, 400); // скрываем его
		}
	});
});

function init_modal(id, title, size) {
	$('.textareaOrder').text(title+' '+size)
	console.log($('.textareaOrder'))
	$('#'+id).css('display', 'block');
	$('#'+id).animate({left: 0}, 400);
}